var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.242503 1.38947C0.101695 1.23233 0.0234681 1.02556 0.0312906 0.810526C0.0312906 0.595489 0.109518 0.396992 0.258148 0.239849C0.398957 0.0909772 0.594524 -4.81113e-07 0.797914 -4.98894e-07C1.0013 -5.16674e-07 1.19687 0.0744357 1.3455 0.223308L5.77314 4.90451C5.84355 4.97895 5.8983 5.06992 5.93742 5.16917C5.97653 5.26842 6 5.37594 6 5.48346C6 5.59098 5.97653 5.6985 5.93742 5.80601C5.8983 5.90526 5.84355 5.99624 5.77314 6.07068L1.3455 10.7519C1.2751 10.8263 1.18905 10.8925 1.09518 10.9338C0.993482 10.9752 0.891787 11 0.790092 11C0.688397 11 0.578879 10.9835 0.485007 10.9421C0.391135 10.9008 0.305086 10.8346 0.226859 10.7602C0.156455 10.6857 0.101696 10.5865 0.062582 10.4872C0.0156459 10.388 8.90769e-07 10.2805 8.80647e-07 10.1647C8.71247e-07 10.0571 0.0234689 9.94962 0.0625819 9.85038C0.101695 9.75113 0.164277 9.66015 0.242504 9.57744L4.11473 5.48346L3.3794 4.71429L0.242503 1.38947Z",
    fill: "#181725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.40f6b95f0bdfe4b12ba0895d849d46f2.svg";
export { ForwardRef as ReactComponent };